export const BASE_API_URL = process.env.VUE_APP_API_URL;

// Twilio Connect App authorize page. Users are sent here to grant us access
// to their Twilio account; Twilio redirects back to /twilio/callback.
export const TWILIO_AUTHORIZE_URL = 'https://www.twilio.com/authorize/CN9ad4ade05530eddf8670dad40ea8834e';
